var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g({staticClass:"wrn-text-center wrn-p-05 simple-button__label wrn-link wrn-display-block-sm",class:{ 'simple-button--disabled': _vm.$attrs.disabled },attrs:{"data-testid":"simple-button-action"}},_vm.$listeners),[_vm._t("default"),_vm._v(" "+_vm._s(_vm.label)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }